/*/
 * Alert
 *
 * Text: string
 * Class: alert--i_success | alert--i_error
 * Seconds: time visible in ms
 *
/*/
	window.siteAlert = function (params) {
		params = {
			text: params.text ? params.text : '',
			class: params.class ? params.class : 'alert--i_success',
			seconds: params.seconds ? params.seconds : 6000,
		}

		const alert = document.createElement('div')
		alert.classList.add('alert--i', params.class)
		alert.innerHTML = params.text

		document.querySelector('#app').appendChild(alert);

		setTimeout(function () { alert.classList.add('is--visible') }, 500)
		setTimeout(function () { alert.classList.remove('is--visible') }, params.seconds)
		setTimeout(function () { alert.remove() }, params.seconds + 500)

		alert.addEventListener('click', function () {
			this.classList.remove('is--visible')
			setTimeout(function () { alert.remove() }, 500)
		})
	}

	window.siteAlertFromAxiosError = function (err, fallback) {
		fallback = fallback || 'Ocorreu um erro. Tente novamente.';
		let text = fallback;
		const data = err && err.response ? err.response.data : null;

		if (typeof data === 'string' && data.trim()) {
			text = data.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 280) || fallback;
		} else if (data && typeof data === 'object') {
			if (data.message !== undefined && data.message !== null) {
				text = Array.isArray(data.message) ? String(data.message[0]) : String(data.message);
			} else if (data.errors && typeof data.errors === 'object') {
				const firstKey = Object.keys(data.errors)[0];
				if (firstKey && data.errors[firstKey] && data.errors[firstKey][0]) {
					text = String(data.errors[firstKey][0]);
				}
			}
		}

		window.siteAlert({
			text: text,
			class: 'alert--i_error',
			seconds: 5000,
		});
	};
